import { ReactNode, ElementType } from 'react';
import BgNsTimelineEvent from '@britishgasenergy/react-nucleus/dist/nuc-components/NsTimelineEvent';

import { NsCard } from 'components/common/ns-card/NsCard';
import { NsIconProps } from 'components/common/ns-icon/NsIcon';

type CardWrapperProps = {
  children: ReactNode;
};

const CardWrapper = ({ children }: CardWrapperProps) => {
  return (
    <NsCard type="support">
      <p>{children}</p>
    </NsCard>
  );
};

type NsTimelineEventProps = {
  heading: string;
  slot?: string;
  status?:
    | 'pending'
    | 'inprogress'
    | 'actionrequired'
    | 'warning'
    | 'error'
    | 'completed'
    | 'cancelled';
  icon?: NsIconProps['type'];
  index?: number;
  updatedAt?: Date;
  children?: ReactNode;
  wrapper?: ElementType<CardWrapperProps>;
  testId?: string;
};

export const NsTimelineEvent = ({
  heading,
  slot = 'event',
  status,
  icon,
  index,
  updatedAt,
  children,
  wrapper: Wrapper = CardWrapper,
  testId
}: NsTimelineEventProps) => {
  return (
    <BgNsTimelineEvent
      slot={slot}
      status={status}
      icon={icon}
      index={index}
      updatedAt={updatedAt}
      data-testid={testId}
    >
      <h3 slot="heading">{heading}</h3>
      {children && <Wrapper>{children}</Wrapper>}
    </BgNsTimelineEvent>
  );
};
